/**
 * Avatar fallback initials.
 *
 * Shared because the same person is rendered by three surfaces — the attendee
 * card, the speaker card, and the profile sheet both open into. Two private
 * copies plus a one-letter `charAt(0)` on the speaker card meant one speaker
 * could show "J" on the card and "JD" in the sheet that card opens.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return (
    parts
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toLocaleUpperCase() || "?"
  );
}
